<template>
  <v-row>
    <dialog-loading loadingText="Salvando..." v-if="saving"></dialog-loading>
    <v-col cols='12' align='center' v-if="loading" >
      <card-loading-transparent ></card-loading-transparent>
    </v-col>
    <v-col cols='12' align='center' v-if="!loading">
      <v-chip v-if="one_bill_status.text" :color="one_bill_status.color" text-color="white" class="mr-2">
        {{ one_bill_status.text }}
      </v-chip>
      <div class="d-flex justify-center flex-wrap">
        <v-btn class="ma-1" outlined color="indigo" :disabled="!bill.attached_file_url && !bill.iugu_bill" :href="bill.attached_file_url || (bill.iugu_bill && bill.iugu_bill.secure_url)" target="_blank">
          Acessar boleto
        </v-btn>
        <v-btn @click="generateInGateway()" :disabled="bill.disabled || bill.concluded || saving" v-if="!bill.gateway_number && !bill.iugu_bill?.id" class="ma-1" outlined color="indigo">
          Gerar boleto SICOOB
        </v-btn>
        <v-btn @click="generateSecondInstanceInGateway()" :disabled="bill.disabled || bill.concluded" v-if="bill.gateway_number && !bill.iugu_bill?.id" class="ma-1" outlined color="indigo">
          Gerar 2º via do boleto
        </v-btn>
        <v-btn @click="verifyBill()" :disabled="bill.disabled || bill.concluded" v-if="bill.gateway_number && !bill.iugu_bill?.id" class="ma-1" outlined color="indigo">
          Verificar status do boleto
        </v-btn>
        <v-btn @click="baixarBoleto()" :disabled="bill.disabled || bill.concluded" v-if="isDirector()" class="ma-1" outlined color="indigo">
          Considerar Pago
        </v-btn>
      </div>
      <v-chip v-if="bill.gateway_log" color="error" class="ma-2"> {{ JSON.parse(bill.gateway_log)?.mensagens?.[0]?.mensagem }} </v-chip>
      <v-divider class="my-2"></v-divider>
      <v-text-field readonly label="Número do documento" v-model="bill.nf_number"></v-text-field>
      <v-text-field readonly label="Nosso número" v-model="bill.our_number" mask="########-#" return-masked-value ></v-text-field>
      <v-text-field readonly label="Empresa" v-model="bill.company"></v-text-field>
      <v-divider class="my-2"></v-divider>
      <template v-if="!bill.iugu_bill">
        <v-input v-if="bill.gateway_number" :messages="bill.gateway_number" class="py-2" prepend-icon="mdi-fingerprint">
          ID Gateway
        </v-input>
        <v-input v-if="bill.value" :messages="bill.value" class="py-2" prepend-icon="mdi-cash">
          Valor total
        </v-input>
        <v-divider></v-divider>
        <v-input v-if="bill.paid_value" :messages="bill.paid_value" class="py-2" prepend-icon="mdi-cash-check">
          Valor pago
        </v-input>
        <v-input v-if="bill.due_date" :messages="bill.due_date" class="py-2" prepend-icon="mdi-calendar">
          Vencimento
        </v-input>
        <v-divider></v-divider>
        <v-input v-if="bill.barcode" :messages="bill.barcode" class="py-2" prepend-icon="mdi-barcode">
          Código de barras
        </v-input>
        <v-input v-if="bill.digitable_line" :messages="bill.digitable_line" class="py-2" prepend-icon="mdi-barcode">
          Linha digitável
        </v-input>
      </template>
      <template v-if="bill.iugu_bill">
        <span>Criada em: {{ bill.iugu_bill.created_at }}</span>
        <v-input :messages="bill.iugu_bill.secure_id" class="py-2" prepend-icon="mdi-fingerprint">
          ID Iugu
        </v-input>
        <v-divider></v-divider>
        <v-input :messages="bill.iugu_bill.total" class="py-2" prepend-icon="mdi-cash">
          Valor total
        </v-input>
        <v-divider></v-divider>
        <v-input :messages="bill.iugu_bill.paid" class="py-2" prepend-icon="mdi-cash-check">
          Valor pago
        </v-input>
        <v-divider></v-divider>
        <v-input v-if='bill.iugu_bill.due_date'
          :messages="$moment(bill.iugu_bill.due_date).format('DD/MM/YYYY')" class="py-2"
          prepend-icon="mdi-calendar"
        >
          Vencimento
        </v-input>
        <v-divider></v-divider>
        <v-input v-if='bill.iugu_bill.bank_slip'
          :messages="bill.iugu_bill.bank_slip.digitable_line" class="py-2" prepend-icon="mdi-barcode"
        >
          Linha digitável
        </v-input>
  
        <template class="pt-4">
          <v-expansion-panels focusable flat active-class="elevation-4" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header class="red--text font-weight-bold">
                Logs
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <bill-logs :logs='bill.iugu_bill.logs'></bill-logs>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
  
          <v-expansion-panels focusable v-if='bill.expired_iugu_bill && bill.expired_iugu_bill.length'>
            <v-expansion-panel  style="border-bottom: solid #ddd 1px;" >
              <v-expansion-panel-header class="red--text font-weight-bold">
                <h3>Expirados</h3>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-row>
                      <v-col cols='12' class='pa-2' v-for="(exp_bill, idx) in bill.expired_iugu_bill"
                        :key="exp_bill.secure_id + idx">
                        <v-card outlined class='pa-2'>
                          <v-btn outlined color="info" small :href="exp_bill.secure_url" target="_blank">
                            Acessar boleto
                          </v-btn>
                          <dialog-bill-logs :logs='exp_bill.logs'></dialog-bill-logs>
                          <v-input :messages="exp_bill.secure_id" class="py-2" prepend-icon="mdi-fingerprint">
                            ID Iugu
                          </v-input>
                          <v-divider></v-divider>
                          <v-input :messages="exp_bill.total" class="py-2" prepend-icon="fa-money-bill-wave-alt">
                            Valor total
                          </v-input>
                          <v-divider></v-divider>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>
  
      </template>
    </v-col>
  </v-row>
</template>

<script>
import Api from '@/api/index';
import {CurrencyDirective} from 'vue-currency-input'
import { mask } from'vue-the-mask'

export default {
  name: "BillProfile",
  components: {
    BillLogs: () => import('@/_backoffice/_financial/components/bill/shared/BillLogs.vue'),
  },
  directives: {
    currency: CurrencyDirective,
    mask,
  },
  props: {
    id: {
      type: [Number, String],
    },
  },
  data() {
    return {
      loading: false,
      saving: false,
      bill: {},
      currency:{
        currency: null,
        locale: 'en-EN',
        autoDecimalMode: true,
        decimalLength: 2,
        distractionFree:false,
      },
      iugu_bill_status: {
        pending: {
          text: 'Pendente',
          color: 'orange',
          icon: '',
        },
        canceled: {
          text: 'Cancelado',
          color: 'red',
          icon: '',
        },
        expired: {
          text: 'Expirado',
          color: 'red',
          icon: '',
        },
        partially_paid: {
          text: 'Pago parcialmente',
          color: 'green',
          icon: '',
        },
        paid: {
          text: 'Pago',
          color: 'green',
          icon: '',
        },
        externally_paid: {
          text: 'Pago Externamente',
          color: 'green',
          icon: '',
        },
      },
    }
  },
  methods: {
    getOneBill(){
      if(this.id){
        this.loading = true
        Api.Bill.show(this.id).then(r=> r.data).then(d=>{
          this.bill = {type: d.data.type, ...d.data.attributes}
        }).catch(err=> {
          console.log({err});
        }).finally(()=>{
          this.loading = false
        })
      }
    },
    generateInGateway(){
      this.swallConfirmation({
          title: 'Deseja gerar boleto SICOOB?',
          icon: 'question',
        }).then( confirmed =>{
          if (confirmed ) {
            this.saving = true
            Api.Bill.generateInGateway(this.id).then(()=>{
              this.successUpdated()
            }).catch(err => {
              const message = err?.response?.data?.errors?.[0] || 'Não foi possível gerar o boleto no SICOOB.'
              this.$swal('Erro', message, 'error')
            }).finally(()=>{
              this.getOneBill()
              this.saving = false
            })
          }
        })
      },
      generateSecondInstanceInGateway(){
        this.swallConfirmation({
          title: 'Deseja gerar 2º Via do boleto?',
          icon: 'question',
        }).then( confirmed =>{
          if (confirmed ) {
            this.saving = true
            Api.Bill.generateSecondInstanceInGateway(this.id).then(()=>{
              this.successUpdated()
            }).finally(()=>{
              this.getOneBill()
              this.saving = false
            })
          }
        })
      },
      verifyBill(){
        this.swallConfirmation({
          title: 'Deseja verificar status do boleto?',
          icon: 'question',
        }).then( confirmed =>{
          if (confirmed ) {
            this.saving = true
            Api.Bill.verifyBill(this.id).then(()=>{
              this.successUpdated()
            }).finally(()=>{
              this.getOneBill()
              this.saving = false
            })
          }
        })
      },
      baixarBoleto(){
        this.swallConfirmation({
          title: 'Deseja baixar o boleto?',
          icon: 'question',
        }).then( confirmed =>{
          if (confirmed ) {
            this.saving = true
            Api.Bill.baixarBoleto(this.id).then(()=>{
              this.successUpdated()
            }).finally(()=>{
              this.getOneBill()
              this.saving = false
            })
          }
        })
      },
  },
  computed: {
    one_bill_status() {
      if (this.bill && this.bill.iugu_bill && this.bill.iugu_bill.status) {
        return this.iugu_bill_status[this.bill.iugu_bill.status]
      }else {
        return {}
      }
    },
  },
  mounted () {
    this.getOneBill()
  },
  watch: {
    id(nv,ov) {
      this.getOneBill()
    },
  },

}
</script>
